
// Image placeholder component used across multiple components
export const ImagePlaceholder = ({ label, className }: { label: string; className?: string }) => (
  <div
    className={`flex items-center justify-center bg-gray-800 text-gray-500 rounded-2xl w-full h-full ${className}`}
  >
    <span className="text-sm tracking-widest uppercase">{label}</span>
  </div>
);

// Arrow right icon component used in HeroSection
export const ArrowRightIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
  </svg>
);
